import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import { database } from '../../../utils/firebase';
import { ref, onValue, push, set } from 'firebase/database';
import './Players.css';
import {
    Breadcrumbs,
    Button,
    DialogTitle,
    Dropdown,
    FormControl,
    FormLabel,
    IconButton,
    Input,
    Link,
    Menu,
    MenuButton,
    MenuItem,
    Modal,
    ModalDialog,
    Select,
    Stack,
    Switch,
    Typography,
    Option,
    CardContent,
    Card,
    Checkbox
} from "@mui/joy";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DateTimePicker} from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import PrintIcon from "@mui/icons-material/Print";
import QuickReportGenerator from "../QuickReportGenerator/QuickReportGenerator";
import {FilterList, SwapVert} from "@mui/icons-material";
import {Popover, TablePagination} from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const Players = () => {
    const navigate = useNavigate();
    const {leagueId} = useParams();

    const playerRef = ref(database, `leagues/${leagueId}/players`);
    const [playerData, setPlayerData] = React.useState({});
    const [playerIds, setPlayerIds] = React.useState([]);

    const [editOpen, setEditOpen] = React.useState(false);
    const [editPlayerId, setEditPlayerId] = React.useState('');
    const [newOpen, setNewOpen] = React.useState(false);
    const [leagueData, setLeagueData] = React.useState({});

    const [newPlayerName, setNewPlayerName] = useState('');
    const [newPlayerJoinDate, setNewPlayerJoinDate] = useState(dayjs(Date.now()));

    const [editPlayerName, setEditPlayerName] = useState('');
    const [editPlayerJoinDate, setEditPlayerJoinDate] = useState(dayjs(Date.now()));
    const [editPlayerActive, setEditPlayerActive] = useState(true);
    const [editPlayerLeaveDate, setEditPlayerLeaveDate] = useState(null);

    const [reportModalOpen, setReportModalOpen] = useState(false);
    const [reportType, setReportType] = useState('');

    const [anchorEl, setAnchorEl] = useState(null);
    const filterMenuOpen = Boolean(anchorEl);

    const [sortField, setSortField] = useState("ln");
    const [sortAsc, setSortAsc] = useState(true);
    const [filterActive, setFilterActive] = useState(false);
    const [filterDate, setFilterDate] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        const leagueRef = ref(database, `leagues/${leagueId}`);
        onValue(leagueRef, (snapshot) => {
            const data = snapshot.val();
            setLeagueData(data);
        });
    }, []);

    useEffect(() => {
        onValue(playerRef, (snapshot) => {
            const data = snapshot.val();
            setPlayerData(data);
            const ids = data ? Object.keys(data) : [];
            setPlayerIds(ids)
        });
    }, [leagueId]);

    const handleEdit = (playerId) => {
        setEditPlayerId(playerId);
        setEditOpen(true);
        setEditPlayerName(playerData[playerId].name);
        setEditPlayerJoinDate(dayjs(playerData[playerId].startDate));
        setEditPlayerActive(playerData[playerId].status === 'active');
        setEditPlayerLeaveDate(playerData[playerId].endDate ? dayjs(playerData[playerId].endDate) : null);
    }


    const handleCreate = () => {
        const playerRef = ref(database, `leagues/${leagueId}/players`);
        const newPlayer = {
            name: newPlayerName,
            status: 'active',
            startDate: newPlayerJoinDate.unix()*1000,
            endDate: null
        };
        push(playerRef, newPlayer);
        setNewPlayerName('');
        setNewPlayerJoinDate(dayjs(Date.now()));
        setNewOpen(false); // Close the dialogue
    };

    const handleSave = () => {
        const playerRef = ref(database, `leagues/${leagueId}/players/${editPlayerId}`);
        const updatedPlayer = {
            name:editPlayerName,
            status: editPlayerActive ? 'active' : 'notactive',
            startDate: editPlayerJoinDate.unix()*1000,
            endDate: editPlayerActive ? null : editPlayerLeaveDate.unix()*1000,
        };
        set(playerRef, updatedPlayer);
        setEditOpen(false); // Close the dialogue

    };

    return (
        <div>
            <div className={'container'}>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" onClick={() => navigate(`/app/league/${leagueId}/dashboard`)}>
                        {leagueData.name}
                    </Link>
                    <Typography sx={{ color: 'text.primary' }}>Players</Typography>
                </Breadcrumbs>
                <div className={"page-head-div"}>
                    <h1>Players</h1>
                    <Dropdown>
                        <MenuButton variant="plain" sx={{width: "35px", height: "35px"}}><PrintIcon/></MenuButton>
                        <Menu>
                            <MenuItem onClick={
                                () => {
                                    setReportModalOpen(true);
                                    setReportType('rosterReport');
                                }}>Roster Report</MenuItem>
                        </Menu>
                    </Dropdown>
                </div>
                <div className={'dashboard'}>
                    <div style={{display:'flex', justifyContent: 'space-between'}}>
                        <Button className={'button-gradient new-player-button'} onClick={() => setNewOpen(true)}>
                            Add Player
                        </Button>
                        <div style={{display:'flex', gap: '10px'}}>
                            <Input
                                type="text"
                                placeholder="Search players..."
                                value={searchQuery}
                                onChange={(e) => {
                                    setSearchQuery(e.target.value);
                                    setPage(0);
                                }}
                                className="mb-4 w-full rounded-lg border px-4 py-2 shadow-sm outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <IconButton variant="plain" sx={{ width: "35px", height: "35px" }} onClick={(event) => {
                                setAnchorEl(event.currentTarget);
                            }}>
                                <FilterList />
                            </IconButton>
                            <Popover
                                open={filterMenuOpen}
                                anchorEl={anchorEl}
                                onClose={() => setAnchorEl(null)}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                sx={{
                                    zIndex: 1,
                                    '& .MuiPaper-root': {
                                        backgroundColor: 'transparent',
                                        boxShadow: 'none'
                                    }
                                }}
                            >
                                <Card>
                                    <CardContent>
                                        <Typography level="title-md">Sort By:</Typography>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <Select value={sortField} onChange={(e, newValue) => setSortField(newValue)}>
                                                <Option value={"ln"}>Last Name</Option>
                                                <Option value={"fn"}>First Name</Option>
                                                <Option value={"jd"}>Join Date</Option>
                                            </Select>
                                            <IconButton onClick={() => setSortAsc(prev => !prev)} variant="outlined">
                                                <SwapVert />
                                            </IconButton>
                                        </div>
                                        <Typography level="title-md" sx={{ mt: 2 }}>Filter By:</Typography>
                                        <Checkbox
                                            label="Currently Active"
                                            checked={filterActive}
                                            onChange={(e) => setFilterActive(e.target.checked)}
                                        />
                                        <Typography level="title-md" sx={{ mt: 2 }}>Active On:</Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                value={filterDate}
                                                onChange={(newDate) => setFilterDate(newDate)}
                                            />
                                        </LocalizationProvider>
                                    </CardContent>
                                </Card>
                            </Popover>
                        </div>
                    </div>
                    <div>
                        {
                            [...playerIds]
                                .filter((id) => {
                                    const player = playerData[id];

                                    // Filter by active status
                                    if (filterActive && player.status !== 'active') return false;

                                    // Filter by date
                                    if (filterDate) {
                                        const join = player.startDate;
                                        const end = player.endDate ?? Infinity;
                                        const filterTime = filterDate.startOf('day').unix() * 1000;
                                        if (!(join <= filterTime && end >= filterTime)) return false;
                                    }

                                    // Filter by search query
                                    return !(searchQuery.trim() &&
                                        !player.name.toLowerCase().includes(searchQuery.toLowerCase()));


                                })
                                .sort((aId, bId) => {
                                    const a = playerData[aId];
                                    const b = playerData[bId];
                                    let aVal = a.name;
                                    let bVal = b.name;

                                    if (sortField === 'jd') {
                                        aVal = a.startDate;
                                        bVal = b.startDate;
                                    } else if (sortField === 'fn' || sortField === 'ln') {
                                        const aSplit = a.name.split(" ");
                                        const bSplit = b.name.split(" ");
                                        aVal = sortField === 'fn' ? aSplit[0] : aSplit[aSplit.length - 1];
                                        bVal = sortField === 'fn' ? bSplit[0] : bSplit[bSplit.length - 1];
                                    }

                                    if (aVal < bVal) return sortAsc ? -1 : 1;
                                    if (aVal > bVal) return sortAsc ? 1 : -1;
                                    return 0;
                                })
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((playerId) => (
                                    <div className={'ldb-match'} key={playerId}>
                                        {playerData[playerId].name}
                                        <div className={'dash-league-item-buttons'}>
                                            <Button className={'button-gradient'} onClick={() => handleEdit(playerId)}>Edit</Button>
                                        </div>
                                    </div>
                                ))
                        }
                        <TablePagination
                            component="div"
                            count={
                                [...playerIds].filter((id) => {
                                    const player = playerData[id];

                                    if (filterActive && player.status !== 'active') return false;

                                    if (filterDate) {
                                        const join = player.startDate;
                                        const end = player.endDate ?? Infinity;
                                        const filterTime = filterDate.startOf('day').unix() * 1000;
                                        if (!(join <= filterTime && end >= filterTime)) return false;
                                    }

                                    if (
                                        searchQuery.trim() &&
                                        !player.name.toLowerCase().includes(searchQuery.toLowerCase())
                                    ) return false;

                                    return true;
                                }).length
                            }
                            page={page}
                            onPageChange={(event, newPage) => setPage(newPage)}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={(event) => {
                                setRowsPerPage(parseInt(event.target.value, 10));
                                setPage(0);
                            }}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                        />
                    </div>
                </div>
            </div>


            <Modal open={newOpen} onClose={() => setNewOpen(false)}>
                <ModalDialog>
                    <DialogTitle>Add new player</DialogTitle>
                    <form
                        onSubmit={(event) => {
                            event.preventDefault();
                            setNewOpen(false);
                            handleCreate();
                        }}
                    >
                        <Stack spacing={2}>
                            <FormControl>
                                <FormLabel>Name</FormLabel>
                                <Input value={newPlayerName} onChange={(event) => setNewPlayerName(event.target.value)} />
                            </FormControl>
                            <FormControl>
                                <FormLabel>Date</FormLabel>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        value={newPlayerJoinDate}
                                        onChange={(newDate) => setNewPlayerJoinDate(newDate)}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                            <Button type="submit">Create</Button>
                        </Stack>
                    </form>
                </ModalDialog>
            </Modal>
            <Modal open={editOpen} onClose={() => setEditOpen(false)}>
                <ModalDialog>
                    <DialogTitle>Edit player</DialogTitle>
                    <form
                        onSubmit={(event) => {
                            event.preventDefault();
                            setEditOpen(false);
                            handleSave();
                        }}
                    >
                        <Stack spacing={2}>
                            <FormControl>
                                <FormLabel>Name</FormLabel>
                                <Input
                                    value={editPlayerName}
                                    onChange={(event) => setEditPlayerName(event.target.value)}
                                />
                            </FormControl>
                            <FormControl>
                                <FormLabel>Date</FormLabel>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        value={editPlayerJoinDate}
                                        onChange={(newDate) => setEditPlayerJoinDate(newDate)}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                            <FormControl orientation={"horizontal"} sx={{width: 300, justifyContent: "space-between"}}>
                                <FormLabel>Active</FormLabel>
                                <Switch
                                    checked={editPlayerActive}
                                    onChange={(event) => setEditPlayerActive(event.target.checked)}
                                />
                            </FormControl>
                            {!editPlayerActive && (
                                <FormControl>
                                    <FormLabel>End Date</FormLabel>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            value={editPlayerLeaveDate}
                                            onChange={(newDate) => setEditPlayerLeaveDate(newDate)}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            )}
                            <Button type="submit">Save</Button>
                        </Stack>
                    </form>
                </ModalDialog>
            </Modal>
            <QuickReportGenerator
                type={reportType}
                id={""}
                modalOpen={reportModalOpen}
                closeModal={() => setReportModalOpen(false)}
                leagueId={leagueId}
            />
        </div>
    );
}

export default Players;